// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"cdee32b9","313":"2fb0e396","453":"48e5a7e8"}[chunkId] + ".chunk.js";
};